<ion-app>
  <top-header></top-header>
  <ion-router-outlet [animated]="false"></ion-router-outlet>
  <app-privacy-policy-popup></app-privacy-policy-popup>
</ion-app>
